<template>
  <div>
    <div class="page f-pr">
      <!-- 底图 -->
      <img src="../assets/history/history-bg.png" alt="" class="bg" />

      <!-- 返回按钮 -->
      <div class="btn-back" @click="goBack">
        <img src="../assets/bar-map/btn-back.png" alt="" />
      </div>

      <!-- 10个地标图标 -->
      <div
        v-for="icon in icons"
        :key="icon.id"
        class="icon-card"
        :class="`icon-${icon.id}`"
        @click="openIcon(icon.id)"
      >
        <img :src="getIconSrc(icon.id)" :alt="icon.name" />
      </div>
    </div>

    <!-- 弹窗：长图可滑动 -->
    <van-overlay :show="showPopup" z-index="999" :lock-scroll="false" @click="showPopup = false">
      <div class="popup-wrap">
        <div class="f-pr popup-con" @click.stop>
          <img :src="currentDetailImg" alt="" class="detail-img" />
        </div>
        <!-- 关闭按钮始终可见 -->
        <div class="close-area" @click.stop="showPopup = false"></div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
const STORAGE_KEY = 'history_map_opened'

export default {
  name: 'HistoryMap',
  data() {
    return {
      showPopup: false,
      currentDetailImg: '',
      currentIconId: null,
      openedSet: new Set(),
      icons: [
        { id: 1, name: '沙梨頭圖書館' },
        { id: 2, name: '內港' },
        { id: 3, name: '內港碼頭' },
        { id: 4, name: '原鴉片屋舊址' },
        { id: 5, name: '夜嘩街' },
        { id: 6, name: '柯邦迪前地' },
        { id: 7, name: '大豐倉' },
        { id: 8, name: '南頂劇院' },
        { id: 9, name: '何東圖書館' },
        { id: 10, name: '媽閣廟' },
      ]
    }
  },
  created() {
    // 读取缓存：已打开的图标
    try {
      const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]')
      saved.forEach(id => this.openedSet.add(id))
    } catch (e) {
      // ignore
    }
  },
  methods: {
    goBack() {
      this.$router.push('/index')
    },
    getIconSrc(id) {
      if (this.openedSet.has(id)) {
        return require(`../assets/history/${id}-g.png`)
      }
      return require(`../assets/history/${id}.png`)
    },
    openIcon(id) {
      // 标记为已打开并缓存
      if (!this.openedSet.has(id)) {
        this.openedSet.add(id)
        localStorage.setItem(STORAGE_KEY, JSON.stringify([...this.openedSet]))
      }
      // 弹出详情长图
      this.currentDetailImg = require(`../assets/history/h-i-${id}.png`)
      this.currentIconId = id
      this.showPopup = true
    }
  }
}
</script>

<style scoped lang="less">
.page {
  position: absolute;
  width: 100%;
  min-height: 100vh;
  left: 0;
  top: 0;
  background: #0a1f1f;
  overflow-x: hidden;
}

.bg {
  display: block;
  width: 750px;
  margin: 0 auto;
}

.btn-back {
  position: fixed;
  left: 23px;
  top: 23px;
  width: 120px;
  z-index: 100;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.6;
  }
}

/* 图标通用样式 */
.icon-card {
  position: absolute;
  cursor: pointer;

  img {
    display: block;
    width: 100%;
  }

  &:active {
    opacity: 0.7;
    transform: scale(0.97);
  }
}

/* 10个图标在底图上的定位（基于 750px 设计稿宽度，原1080px按比例换算） */
.icon-1  { left: 358px; top: 303px;  width: 378px; }
.icon-2  { left: 48px;  top: 530px;  width: 348px; }
.icon-3  { left: 38px; top: 790px;  width: 373px; }
.icon-4  { left: 328px;  top: 955px;  width: 376px; }
.icon-5  { left: 458px; top: 1220px; width: 244px; }
.icon-6  { left: 35px;  top: 1338px; width: 400px; }
.icon-7  { left: 35px; top: 1688px; width: 338px; }
.icon-8  { left: 242px;  top: 1839px; width: 488px; }
.icon-9  { left: 238px; top: 2094px; width: 483px; }
.icon-10 { left: 68px; top: 2320px; width: 498px; }

/* 弹窗 */
.popup-wrap {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.6);
  padding: 50px 0 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.popup-con {
  width: 90%;
  max-width: 700px;
}

.detail-img {
  display: block;
  width: 100%;
  border-radius: 16px;
}

.close-area {
  position: fixed;
  right: 79px;
  bottom: 90px;
  width: 138px;
  height: 100px;
  cursor: pointer;
  z-index: 1000;

  &:active {
    opacity: 0.7;
  }
}
</style>
